import { z } from 'zod';

export const CreateClientGroupDto = z.object({
  name: z.string().min(1).max(255),
  color: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  memberOrgUserIds: z.array(z.string().uuid()).optional(),
});

export type ApiCreateClientGroupDto = z.infer<typeof CreateClientGroupDto>;

export const UpdateClientGroupDto = z.object({
  name: z.string().min(1).max(255).optional(),
  color: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  addMemberOrgUserIds: z.array(z.string().uuid()).optional(),
  removeMemberOrgUserIds: z.array(z.string().uuid()).optional(),
});

export type ApiUpdateClientGroupDto = z.infer<typeof UpdateClientGroupDto>;

export const AddGroupMemberDto = z.object({
  clientOrgUserId: z.string().uuid(),
});

export type ApiAddGroupMemberDto = z.infer<typeof AddGroupMemberDto>;
